export const getIsBazaarvoiceStaging = () =>
  Boolean(process.env.BAZAARVOICE_API_URL?.includes('stg.'));

export const getBazaarvoiceLoaderUrl = (locale: string, isStaging: boolean) =>
  `https://apps.bazaarvoice.com/deployments/mec/main_site/${
    isStaging ? 'staging' : 'production'
  }/${locale}_CA/bv.js`;
